import YouTube from 'react-youtube';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export type FeaturedVideoSectionProps = {
  youtubeId: string;
  title: string;
  description?: string | null;
};

export function FeaturedVideoSection({ youtubeId, title, description }: FeaturedVideoSectionProps) {
  return (
    <Box as='section' bgColor='accent.sky.100' padding='40px 0px'>
      <ContentContainer
        alignItems='center'
        display='flex'
        flexDirection={{
          base: 'column',
          md: 'row',
        }}
        gap={{
          base: 6,
          md: '72px',
        }}
      >
        <Flex
          flexDirection='column'
          flex={{
            md: '1 1 448px',
          }}
          gap={{
            base: 2,
            md: 4,
          }}
          textAlign={{
            base: 'center',
            md: 'start',
          }}
        >
          <Heading
            as='h2'
            size={{
              base: 'marketing-3xl',
              md: 'marketing-4xl',
            }}
          >
            {title}
          </Heading>
          {!!description && (
            <Heading as='p' color='blue.400' size={{ base: 'marketing-lg', md: 'marketing-xl' }}>
              {description}
            </Heading>
          )}
        </Flex>

        <Box
          width='100%'
          flex={{
            md: '1 1 600px',
          }}
        >
          <YouTube
            title={title}
            videoId={youtubeId}
            opts={{
              host: 'https://www.youtube-nocookie.com',
              playerVars: {
                rel: 0,
              },
              width: '100%',
              height: '100%',
            }}
            style={{
              aspectRatio: 16 / 9,
            }}
            onPlay={() => {
              // TODO: add track event
            }}
          />
        </Box>
      </ContentContainer>
    </Box>
  );
}
